function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import ContextTip from "./ContextTip";
import "./Context.css";

/**
 * Context provides styling elevating itself from the background.
 *
 * You normally won't need Context, consider if [Tooltip](/docs/tooltip--default) or [Dropdown](/docs/dropdown--default-story)  meet your needs first.
 * Context is a building block used within Axiom you can use it in combination with [Position](/docs/position--default) to create custom popups.
 */
export default class Context extends Component {
  render() {
    const {
      className,
      arrowRef,
      children,
      maxHeight,
      position,
      width,
      color,
      ...rest
    } = this.props;
    const classes = classnames(className, "ax-context", {
      [`ax-context--${color}`]: color
    });
    const content = () => /*#__PURE__*/React.createElement("div", {
      className: "ax-context__content",
      style: {
        maxHeight
      }
    }, children);
    return /*#__PURE__*/React.createElement(Base, _extends({
      theme: "day"
    }, rest, {
      className: classes,
      style: {
        width
      }
    }), arrowRef ? /*#__PURE__*/React.createElement(ContextTip, {
      color: color,
      direction: position,
      ref: arrowRef
    }, content()) : content());
  }
}
_defineProperty(Context, "defaultProps", {
  maxHeight: "30rem",
  position: "top",
  width: "14.5rem"
});